import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  AnswersSelector,
  BusinessChoiceSelector,
  CounterSelector,
} from 'store/selectors';

import { RadioGroup, SlideFade, Text, VStack } from '@chakra-ui/react';
import AppRoutes from 'config/AppRoutes';
import PageLayout from 'ui/layout/PageLayout';
import { updateCounter, updateInverter } from 'store/answers/answersSlice';
import config from 'config/config';
import { RadioWithImage } from 'ui/molecules/RadioWithImage';
import Button from 'ui/molecules/Button';
import { AssetType, getAsset } from 'utils/hooks/useAsset';
import { SimpleModal } from 'components/SimpleModal';
import useStepNavigation from 'utils/hooks/useStepNavigation';
import { getApiItems } from 'store/hooks/useApiItems';
import useCounterConfig from './hooks/useCounterConfig';

const PageCounter = () => {
  const { t } = useTranslation();
  const currentRoute = AppRoutes.COUNTER;
  const { navigateToNextStep, navigateToPreviousStep } =
    useStepNavigation(currentRoute);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [explanationModalOpen, setExplanationModalOpen] =
    useState<boolean>(false);
  const { defaultCounter } = useCounterConfig();
  const answers = useSelector(AnswersSelector);
  const businessChoice = useSelector(BusinessChoiceSelector);
  const userCounter = useSelector(CounterSelector);

  // filter the counter list according the network types available for inverters
  const apiItems = getApiItems();
  const configCounter = config.options.counter.filter((item) =>
    apiItems.inverters.some((inverter) => inverter.networkType === item.type)
  );

  const handleChange = (selection: string) => {
    dispatch(updateCounter(selection));
  };

  const handleContinue = () => {
    // TODO: later remove this, we are setting automatically the default inverter for now as we skip the inverter page
    dispatch(updateInverter(config.options.inverters[0].id)); // We force SolarEdge inverter
    navigateToNextStep();
  };
  const handleSkip = () => {
    dispatch(updateCounter(defaultCounter.id));
    // TODO ANTHO: Should we not update the inverter here ?
    handleContinue();
  };

  // --------------------- effects ------------------------

  // --------------------- render ------------------------

  return (
    <PageLayout
      title={t('COUNTER_title')}
      buttonLabel={t('common.continue')}
      buttonCallback={handleContinue}
      backButton
      buttonDisabled={!userCounter}
      backCallback={navigateToPreviousStep}
      buttonSticky={false}
    >
      <Text
        // onClick={() => setIsModalOpen(true)}
        // cursor="pointer"
        userSelect="none"
        textAlign="center"
        px="5px"
        // pb="10px"
        // pt="5px"
      >
        {t('COUNTER_description_a')}
        {/* </span>{' '} */} {t('COUNTER_description_b')}
      </Text>

      <RadioGroup
        onChange={handleChange}
        as={VStack}
        defaultValue={userCounter}
        pt="5px"
        pb="20px"
        w="full"
        maxWidth="500px"
        spacing="13px"
      >
        {configCounter.map((item, i) => (
          <SlideFade
            key={item.id}
            in
            offsetX="100px"
            offsetY="0px"
            style={{ width: '100%' }}
            transition={{ enter: { delay: i * 0.05 } }}
          >
            <RadioWithImage
              value={item.id}
              label={t(`COUNTER.${item.id}`)}
              image={getAsset(
                AssetType.IMAGE,
                `/counter/${item.id}.png`,
                answers
              )}
            />
          </SlideFade>
        ))}
      </RadioGroup>

      <Button
        variant="skip"
        width="full"
        onClick={() => setExplanationModalOpen(true)}
      >
        {t('COUNTER_skip')}
      </Button>

      <SimpleModal
        isOpen={isModalOpen}
        description={t('COUNTER_modal')}
        onClose={() => setIsModalOpen(false)}
      />

      <SimpleModal
        isOpen={explanationModalOpen}
        description={t('COUNTER_unknown_type_explanation', {
          counter:
            businessChoice === 'b2b' ? t('COUNTER.tri_n') : t('COUNTER.mono'),
        })}
        onClose={() => setExplanationModalOpen(false)}
        button={
          <Button onClick={() => handleSkip()}>{t('common.continue')}</Button>
        }
        modalContentProps={{
          maxWidth: { base: '90vw', md: '600px' },
        }}
      />
    </PageLayout>
  );
};

export default PageCounter;
